/* VELTRO — scripts propios (vanilla, sin librerías) */
(function () {
  function initReveal() {
    var els = document.querySelectorAll('.vt-reveal:not(.vt-visible)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('vt-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('vt-visible'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initCountUp() {
    var els = document.querySelectorAll('[data-vt-count]:not([data-vt-done])');
    if (!els.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target; io.unobserve(el); el.setAttribute('data-vt-done', '');
        var end = parseFloat(el.getAttribute('data-vt-count')) || 0;
        var dec = (String(end).split('.')[1] || '').length;
        var t0 = null, dur = 1400;
        function step(t) {
          if (!t0) t0 = t;
          var p = Math.min((t - t0) / dur, 1), v = end * (1 - Math.pow(1 - p, 3));
          el.textContent = v.toFixed(dec);
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Página de producto: galería + variantes + cantidad + barra fija */
  function initProduct(root) {
    if (!root || root.dataset.vtReady) return;
    root.dataset.vtReady = '1';
    var main = root.querySelector('[data-vt-main]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-vt-thumb]'));
    var current = 0;

    function show(i) {
      if (!thumbs.length) return;
      current = (i + thumbs.length) % thumbs.length;
      var t = thumbs[current];
      main.src = t.dataset.src; main.srcset = t.dataset.srcset || '';
      main.alt = t.dataset.alt || '';
      thumbs.forEach(function (x, j) { x.classList.toggle('is-active', j === current); });
      t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
    var prev = root.querySelector('[data-vt-prev]'), next = root.querySelector('[data-vt-next]');
    if (prev) prev.addEventListener('click', function () { show(current - 1); });
    if (next) next.addEventListener('click', function () { show(current + 1); });

    var dataEl = root.querySelector('[data-vt-variants]');
    var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    var idInput = root.querySelector('input[name="id"]');
    var addBtn = root.querySelector('[data-vt-add]');
    var addLabel = addBtn && addBtn.querySelector('span');
    var priceEl = root.querySelector('[data-vt-price]');
    var compareEl = root.querySelector('[data-vt-compare]');
    var saveEl = root.querySelector('[data-vt-save]');
    var stickyPrice = document.querySelector('[data-vt-sticky-price]');
    var money = root.dataset.moneyFormat || '${{amount}}';
    var txtAdd = root.dataset.txtAdd, txtSold = root.dataset.txtSold, txtUnavail = root.dataset.txtUnavailable;

    function fmt(cents) {
      var v = (cents / 100).toFixed(2);
      var parts = v.split('.');
      var withComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return money
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, withComma)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, parts[0] + ',' + parts[1])
        .replace(/\{\{\s*amount\s*\}\}/, withComma + '.' + parts[1]);
    }

    function selected() {
      var opts = [];
      root.querySelectorAll('[data-vt-option]').forEach(function (fs) {
        var c = fs.querySelector('input:checked');
        opts.push(c ? c.value : null);
        var lab = fs.querySelector('legend span'); if (lab && c) lab.textContent = c.value;
      });
      return opts;
    }

    function markAvailability(opts) {
      root.querySelectorAll('[data-vt-option]').forEach(function (fs, idx) {
        fs.querySelectorAll('input').forEach(function (inp) {
          var test = opts.slice(); test[idx] = inp.value;
          var ok = variants.some(function (v) {
            return v.available && v.options.every(function (o, k) { return o === test[k]; });
          });
          var label = inp.nextElementSibling;
          if (label) label.classList.toggle('is-unavailable', !ok);
        });
      });
    }

    function update() {
      var opts = selected();
      var v = variants.find(function (x) { return x.options.every(function (o, k) { return o === opts[k]; }); });
      markAvailability(opts);
      if (!v) {
        if (addBtn) { addBtn.setAttribute('disabled', 'disabled'); addLabel.textContent = txtUnavail; }
        return;
      }
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = fmt(v.price);
      if (stickyPrice) stickyPrice.textContent = fmt(v.price);
      if (compareEl) {
        var onSale = v.compare_at_price && v.compare_at_price > v.price;
        compareEl.textContent = onSale ? fmt(v.compare_at_price) : '';
        compareEl.hidden = !onSale;
        if (saveEl) {
          saveEl.hidden = !onSale;
          if (onSale) saveEl.textContent = saveEl.dataset.label.replace('[x]', Math.round((1 - v.price / v.compare_at_price) * 100) + '%');
        }
      }
      if (addBtn) {
        if (v.available) { addBtn.removeAttribute('disabled'); addLabel.textContent = txtAdd; }
        else { addBtn.setAttribute('disabled', 'disabled'); addLabel.textContent = txtSold; }
      }
      if (v.featured_media && thumbs.length) {
        var idx = thumbs.findIndex(function (t) { return t.dataset.mediaId === String(v.featured_media.id); });
        if (idx > -1) show(idx);
      }
      if (window.history && window.history.replaceState && !root.closest('.shopify-design-mode')) {
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    root.querySelectorAll('[data-vt-option] input').forEach(function (i) { i.addEventListener('change', update); });
    if (variants.length) update();

    var qty = root.querySelector('[data-vt-qty]');
    if (qty) {
      var input = qty.querySelector('input');
      qty.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var n = (parseInt(input.value, 10) || 1) + (b.dataset.step === '+' ? 1 : -1);
          input.value = Math.max(1, n);
        });
      });
    }

    var sticky = document.querySelector('[data-vt-sticky]');
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { sticky.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0); });
      }).observe(addBtn);
      var go = sticky.querySelector('button');
      if (go) go.addEventListener('click', function () { if (!addBtn.disabled) addBtn.click(); else addBtn.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
    }
  }

  function initAll() {
    initReveal();
    initCountUp();
    document.querySelectorAll('[data-vt-product]').forEach(initProduct);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
